<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    append-to-body
    :title="$l('dialog_title_generatePurchase') || '生成工厂采购单'"
    width="600px"
    :close-on-click-modal="false"
    :before-close="() => $refs.main.cancel()"
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :params="params"
      @close="close"
      @reload="$emit('reload')"
    />
    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button type="primary" size="small" @click="$refs.main.save()">
        {{ $l('INDEX.btn_confirm') || '确认' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    params: { type: Object, default: () => {} },
  },
  methods: {
    close() {
      this.$emit('close')
      this.$emit('update:visible', false)
    },
  },
}
</script>
